<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">索道设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="deviceName">
            <el-input
              v-model="deviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否开放">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqStatusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="索道名称"
              ></el-table-column>
              <el-table-column prop="DeviceNo" label="编号">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).DeviceNo
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column prop="IsOnline" label="是否开放">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == 0" style="color:red;"
                    >离线</span
                  >
                  <span v-else-if="scope.row.IsOnline == 1" style="color:green;"
                    >在线</span
                  >
                </template></el-table-column
              >
              <el-table-column prop="Longitude" label="经度"></el-table-column>
              <el-table-column prop="Latitude" label="纬度"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "RopewayEquipmentView",
  controller: "UI",
  action: "RopewayEquipmentView",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: "",
      EqStatusArr: [
        { value: true, label: "开放" },
        { value: false, label: "关闭" },
      ],
      IsOnline: ""
    };
  },
  created: function() {
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "索道设备管理查看";
    this.logInfo.LogMessage ="索道设备管理查看";
    this.logInfo.ModuleName = "设备管理";
    this.logInfo.PageName = "索道设备列表页";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        DeviceName: this.deviceName,
        IsOnline: this.IsOnline,
        EquipmentType: "Ropeway",
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/RopewayEquipmentInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/equipment/ui/RopewayEquipmentInfo",
        query: { InfoId: row.DeviceId, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/equipment/ui/RopewayEquipmentInfo",
        query: { InfoId: row.DeviceId, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.TranResourcesApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.logInfo.ActionName = "索道设备信息删除";
              this.logInfo.LogMessage = r
                ? "索道设备信息删除成功"
                : "索道设备信息删除失败";
              this.logInfo.ModuleName = "设备管理";
              this.logInfo.PageName = "索道设备列表页";
              this.addOperationLog();
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.deviceName = "";
      this.IsOnline = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
